module.exports = __webpack_public_path__ + "img/c04_unitstartechsparabarachampion_Normal_ua.4b78aada.webp";